
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 512 512","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M383.55 128.45c7.427 7.427 7.427 19.468 0 26.894L155.344 383.55c-7.426 7.427-19.467 7.427-26.894 0s-7.427-19.468 0-26.894L356.656 128.45c7.426-7.427 19.467-7.427 26.894 0z","fill":"#000"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M128.45 128.45c7.427-7.427 19.468-7.427 26.894 0L383.55 356.656c7.427 7.426 7.427 19.467 0 26.894s-19.468 7.427-26.894 0L128.45 155.344c-7.427-7.426-7.427-19.467 0-26.894z","fill":"#000"}})])
          )
        }
      }
    